import Vue from 'vue'
import { parse, format } from 'date-fns'
import {
  getS3Url,
  upperFirst,
  thousand,
  getLocaleDateStr,
  getRankStr,
  getPluralString
} from '@/libs/utils'
import { getOsIconName, getBrowserIconName } from '@/libs/analytics-helper'

Vue.filter('fixed', (value, digits) => {
  // https://www.jacklmoore.com/notes/rounding-in-javascript/
  value = Number(Math.round(`${value}e${digits}`) + `e-${digits}`)
  return value.toFixed(digits)
})

Vue.filter('round', value => {
  value = Number(value)
  return Math.round(value)
})

Vue.filter('thousand', value => {
  return thousand(value)
})

Vue.filter('suffixPlus', (value, limit) => {
  if (!limit) {
    limit = 999
  }
  if (value > limit) {
    return limit + '+'
  }
  return value
})

Vue.filter('upper', value => {
  value = String(value)
  return value.toUpperCase()
})

Vue.filter('upperFirst', value => {
  return upperFirst(value)
})

Vue.filter('scrollPvToPv', value => {
  value = Number(value)

  if (isNaN(value)) {
    return '∞'
  } else {
    return value.toFixed(1)
  }
})

Vue.filter('dateFormat', (value, formatString) => {
  return format(parse(value), formatString)
})

Vue.filter('dotDate', (value, defaultString) => {
  if (!value) {
    return defaultString || null
  }
  return format(parse(value), 'YYYY. MM. DD')
})

Vue.filter('dashDate', (value, defaultString) => {
  if (!value) {
    return defaultString || null
  }
  return format(parse(value), 'YYYY-MM-DD')
})

Vue.filter('dateAndTime', value => {
  return format(parse(value), 'YYYY-MM-DD HH:mm:ss')
})

Vue.filter('time', value => {
  return format(parse(value), 'HH:mm:ss')
})

Vue.filter('localeDate', (value, defaultString) => {
  return getLocaleDateStr(value, defaultString)
})

Vue.filter('milliSeconds', value => {
  let oneSecond = 1000
  let oneMinute = oneSecond * 60
  let oneHour = oneMinute * 60
  let oneDay = oneHour * 24

  let ms = value % 1000
  let seconds = Math.floor((value % oneMinute) / oneSecond)
  let minutes = Math.floor((value % oneHour) / oneMinute)
  let hours = Math.floor((value % oneDay) / oneHour)
  let days = Math.floor(value / oneDay)

  let timeString = ''
  if (days !== 0) {
    timeString += (days !== 1) ? (days + ' days ') : (days + ' day ')
  }
  if (hours !== 0) {
    timeString += hours + 'h '
  }
  if (minutes !== 0) {
    timeString += minutes + 'm '
  }
  let firstMs = ms.toString()[0]
  timeString += seconds + (firstMs === 0 ? 's' : '.' + firstMs + 's')

  return timeString
})

Vue.filter('rank', value => {
  return getRankStr(value)
})

Vue.filter('clicks', value => {
  const unit = getPluralString(value, 'click')
  return `${thousand(value)} ${unit}`
})

Vue.filter('streamElementType', value => {
  if (!value) {
    return 'ETC'
  }

  value = value.toLowerCase()

  switch (value) {
    case 'a':
      return 'Link'
    default:
      return upperFirst(value)
  }
})

Vue.filter('streamEventType', value => {
  if (!value) {
    return 'ETC'
  }

  value = value.toLowerCase()

  switch (value) {
    case 'click':
      return 'Click'
    case 'focus':
      return 'Focus'
    case 'mouseover':
      return 'MouseOver'
    case 'touchmove':
      return 'TouchMove'
    case 'touchend':
      return 'TouchEnd'
    default:
      return value
  }
})

Vue.filter('matchType', (value, shortFormat) => {
  switch (value) {
    case 'exact':
      return 'Exact'
    case 'simple':
      return 'Simple'
    case 'start':
      // return shortFormat ? 'Starts' : 'Starts with'
      return 'Starts'
    case 'end':
      // return shortFormat ? 'Ends' : 'Ends with'
      return 'Ends'
    case 'contains':
      return 'Contains'
    case 'regexp':
      return 'RegExp'
    default:
      return 'Exact'
  }
})

Vue.filter('applyUrlStr', value => {
  switch (value.matchType) {
    case 'exact':
    case 'simple':
    case 'start':
      return value.url
    case 'end':
    case 'contains':
    case 'regexp':
      if (value.matchString) {
        return value.matchString
      } else {
        return value.url
      }
    default:
      return value.url
  }
})

Vue.filter('applyUrl', value => {
  switch (value.matchType) {
    case 'exact':
      return value.url
    case 'simple':
    case 'start':
    case 'end':
    case 'contains':
    case 'regexp':
      if (value.captureURL) {
        return value.captureURL
      } else {
        return value.url
      }
    default:
      return value.url
  }
})

Vue.filter('s3Url', (value, timestamp) => {
  return getS3Url(value, timestamp)
})

Vue.filter('osIconName', value => {
  return getOsIconName(value)
})

Vue.filter('browserIconName', value => {
  return getBrowserIconName(value)
})
